{
	"required": "Campo obrigatório",
	"passwordMustBeSame": "As senhas precisam ser iguais",
	"minLength": "A senha deve ter no mínimo {{count}} caracteres",
	"passwordUppercase": "A senha deve conter pelo menos uma letra maiúscula",
	"passwordLowercase": "A senha deve conter pelo menos uma letra minúscula",
	"passwordNumber": "A senha deve conter pelo menos um número",
	"passwordSpecial": "A senha deve conter pelo menos um caractere especial"
}
